import { Component, ViewChild } from '@angular/core'
import { Auth } from '@angular/fire/auth'
import { collection, Firestore, getDocs, orderBy, query, setDoc } from '@angular/fire/firestore'
import { FormControl, FormGroup, Validators } from '@angular/forms'
import { MatSnackBar } from '@angular/material/snack-bar'
import { MatSort } from '@angular/material/sort'
import { MatTableDataSource } from '@angular/material/table'
import { Subscription } from 'rxjs'
import { debounceTime, distinctUntilChanged } from 'rxjs/operators'
import { hunPhoneNumberValidator } from 'src/app/service/phone-number-validator'
import { TrainersService } from 'src/app/service/trainer.service'
import { Trainer } from 'src/domain/dog'

@Component({
    templateUrl: './trainer-list.component.html',
    styleUrls: ['./trainer-list.component.scss'],
    standalone: false
})
export class TrainerListComponent {
  displayedColumns = ['index', 'name', 'phone', 'email', 'actions']
  trainerList: MatTableDataSource<Trainer> = new MatTableDataSource<Trainer>()
  trainerForm = new FormGroup({
    name: new FormControl(null, Validators.required),
    email: new FormControl(null, [Validators.email, Validators.required]),
    phone: new FormControl(null, hunPhoneNumberValidator),
  })
  showTrainerForm = false

  searchControl: FormControl = new FormControl()

  private sub = new Subscription()

  @ViewChild(MatSort, { static: true })
  sort: MatSort

  constructor(private service: TrainersService, private store: Firestore, private auth: Auth, private snack: MatSnackBar) { }

  async ngOnInit() {
    await this.refreshTrainers()

    this.trainerList.sort = this.sort
    this.sort.sort({ id: 'name', start: 'asc', disableClear: false })

    this.searchControl.valueChanges.pipe(debounceTime(300), distinctUntilChanged()).subscribe((key: string) => {
      this.trainerList.filter = key.toLocaleLowerCase()
    })
  }

  private async refreshTrainers() {
    const ts = await getDocs(query(collection(this.store, 'trainers'), orderBy('name')))

    const trainers = ts.docs.map((doc) => doc.data() as Trainer).filter(t => t.deletedAt == null)
    this.trainerList.data = trainers
  }

  async saveTrainer() {
    if (this.trainerForm.valid) {
      const createdAt = new Date()
      const data = this.trainerForm.value
      const trainerId = data.email
      const trainerDoc = this.service.getTrainerDoc(trainerId)
      const createdBy = this.auth.currentUser.email
      try {
        await setDoc(trainerDoc, {
          trainerId,
          name: data.name,
          email: data.email,
          phone: data.phone,
          createdAt,
          createdBy,
        })
        this.snack.open(`${data.name} sikeresen mentve`, 'Oké', { duration: 2000 })

        this.trainerForm.reset({})
        this.showTrainerForm = false
        this.refreshTrainers()
      } catch (e) {
        console.error(e)
        this.snack.open(`${data.name} nem sikerült elmenteni`, 'Ajaj')
      }
    }
  }

  ngOnDestroy(): void {
    this.sub.unsubscribe()
  }

  toggleTrainerForm() {
    this.showTrainerForm = !this.showTrainerForm
  }
}
